import React from 'react';
import PropTypes from 'prop-types';
import Card from '../../components/Card';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import HeaderSearchRefreshFilterOptions from '../../components/HeaderSearchRefreshFilterOptions';
import CardBody from '../../components/CardBody';
import Paginator from '../../components/Paginator';
import AddMessage from '../../../messages-notifications/messages/to-refactor/card/AddMessage';
import Row from '../../components/Row';
import CardHeader from '../../components/card-header/CardHeader';
import { MessagesList } from './MessagesList';
import { MessageState } from '../../model/MessageState';
import { MessageSearchRequest } from './message-search/MessageSearchRequest';
import { MessageSearchTask } from './message-search/MessageSearchTask';
import { PsMessage } from '../../../messages-notifications/messages/PsMessage';

export class MessagesCard extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            page: 1,
            data: [],
            error: '',
            filter: props.initialCardState.filter,
            search: props.initialCardState.search,
            loading: false,
            filters: this.initialFilterOptions(),
            collapsed: props.initialCardState.collapsed,
            pagination: {
                current: 0,
                total_pages: 0,
                total_elements: 0,
            },
        };
    }

    componentDidMount() {
        if (!this.state.collapsed) {
            this.listMessages();
        }
    }

    componentDidUpdate(_, prevState) {
        const { saveCardState } = this.props;
        const { search, filter, collapsed } = this.state;

        if ((prevState.collapsed !== collapsed) && !collapsed) {
            this.listMessages();
        }

        if ( prevState.filter !== filter ) {
            saveCardState({ filter });
        }

        if ( prevState.search !== search ) {
            saveCardState({ search });
        }

        if ( prevState.collapsed !== collapsed ) {
            saveCardState({ collapsed });
        }
    }

    render() {
        const {
            canAddMessage,
            canResponseMessage,
        } = this.props;

        const {
            data,
            error,
            search,
            loading,
            collapsed,
            pagination,
        } = this.state;

        return (
            <Row>
                <Card loading={loading}>
                    <CardHeader
                        title={I18nUtils.tr('TR_MENSAJES').toUpperCase()}
                        subtitle={this.subtitle()}
                        rightOptions={(
                            <HeaderSearchRefreshFilterOptions
                                enableFilter={true}
                                collapsed={collapsed}
                                searchText={search}
                                filterOptions={this.filterOptions()}
                                onRefresh={this.listMessages}
                                onSearch={this.search}
                                onCollapsed={this.collapse}
                            />
                        )}
                    />
                    {
                        !collapsed ? (
                            <CardBody>
                                {
                                    canAddMessage ? (
                                        <AddMessage addMessageSuccess={this.addMessage}/>
                                    ) : null
                                }
                                <MessagesList
                                    data={data}
                                    error={error}
                                    canResponseMessage={canResponseMessage}
                                />
                                <Paginator
                                    data={pagination}
                                    onPage={this.selectPage}
                                />
                            </CardBody>
                        ) : null
                    }
                </Card>
            </Row>
        );
    }

    initialFilterOptions = () => {
        return [
            {
                id: MessageState.ALL,
                title: I18nUtils.tr('TR_TODAS'),
                onClick: () => this.setState({ filter: MessageState.ALL, page: 1 }, this.listMessages),
            },
            {
                id: MessageState.ACTIVE,
                title: I18nUtils.tr('TR_ABIERTAS'),
                onClick: () => this.setState({ filter: MessageState.ACTIVE, page: 1 }, this.listMessages),
            },
            {
                id: MessageState.INACTIVE,
                title: I18nUtils.tr('TR_CERRADAS'),
                onClick: () => this.setState({ filter: MessageState.INACTIVE, page: 1 }, this.listMessages),
            },
        ];
    };

    filterOptions = () => {
        return this.state.filters.map((filter) => ( {
            ...filter,
            active: filter.id === this.state.filter,
        } ));
    };

    subtitle = () => {
        const currentFilter = this.state.filters.find((f) => f.id === this.state.filter);
        return currentFilter ? currentFilter.title : '';
    };

    search = (search) => {
        this.setState({ search: search, page: 1 }, this.listMessages);
    };

    selectPage = (page) => {
        this.setState({ page }, this.listMessages);
    };

    collapse = () => {
        this.setState((prevState) => ( { collapsed: !prevState.collapsed } ));
    };

    addMessage = () => {
        this.setState({ page: 1, search: '', filter: 0 }, this.listMessages);
    };

    listMessages = () => {
        const { companyId } = this.props;
        const { page, search, filter } = this.state;
        const request = new MessageSearchRequest(companyId);

        request.setPage(page);
        request.setTerm(search);
        request.setState(filter);

        new MessageSearchTask(request)
            .onPreExecution(() => this.setState({ loading: true }))
            .onSuccess((res) => {
                this.setState({
                    data: PsMessage.fromAPIMessages(res.data),
                    pagination: res.pagination,
                });
            })
            .onFail(error => this.setState({ error }))
            .onPostExecution(() => this.setState({ loading: false }))
            .execute();
    };
}

MessagesCard.propTypes = {
    companyId: PropTypes.number,
    canAddMessage: PropTypes.bool,
    canResponseMessage: PropTypes.bool,
    saveCardState: PropTypes.func,
    initialCardState: PropTypes.object,
};

MessagesCard.defaultProps = {
    canAddMessage: false,
    canResponseMessage: false,
    saveCardState: () => null,
    initialCardState: {
        search: '',
        filter: MessageState.ALL,
        collapsed: false,
    },
};



// WEBPACK FOOTER //
// ./src/app/shared/message/list/MessagesCard.jsx